export default {
  loc: "English",
  page: {
    organizeData: "Organize abnormal data",
    root: "Root directory",
  },
  tableHeard: {
    name: "Name",
    describe: "Describe",
    size: "Size",
  },
  text: {
    test: "Test",
  },
  form: {
    name: "User name",
    pw: "Password",
    rules: {
      name: "Please enter user name",
      pw: "Please enter password",
      len: "Length should be 3 to 20 bits",
    },
  },
  button: {
    confirm: "Confirm",
    cancel: "Cancel",
    login: "Login",
    logout: "Logout",
    getdata: "Get data",
    application: "Application",
    datePicker: {
      start: "Start time",
      end: "End time",
      last: {
        day: "Last 24 hours",
        week: "Last week",
        month: "Last month",
        threemonth: "Last three months",
      },
    },
    leavemessage: "Leave us a message",
    download: "Download",
    extract: "Extract file",
  },
  state: {
    success: "Success",
    error: "Error",
  },
  rules: {
    nonull: {},
    mustNumber: "Must be a number",
    positiveNumber: "Must be positive number",
    min1: "Must be greater than 0",
  },
  tips: {
    nodata: "No data",
    download: "Download",
    noexist: "File does not exist",
    maxdownload: "Download thread reached maximum",
    notfound: "Not found",
  },
  goto: {
    title: "Query Download",
    input: "Please enter the device model (e.g. MSD)",
  },
};
